module.exports = __webpack_public_path__ + "assets/img/00014.6f587f03.png";